module.exports = __webpack_public_path__ + "img/ornament1.d3a02f0f.jpg";